<template>
  <div class="term-tag-header__wrapper">
    <a-show-more
      class="term-tag-header__description-wrapper"
      v-bind="descriptionProps"
    >
      <a-render-html
        :html="description"
        class="term-tag-header__description text-body"
      />
    </a-show-more>
  </div>
</template>

<script>
import mixins from '@/utils/mixins'
import { propValidator, PROP_TYPES } from '@/utils/validators'
import AShowMore from 'shared/AShowMore'
import { processHtml } from '@/utils/helpers/processHtml'
import ARenderHtml from 'shared/ARenderHtml'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'

export default {
  name: 'TermTagHeader',
  mixins: [mixins.urlGenerators, hydrationHelpers],
  components: { ARenderHtml, AShowMore },
  props: {
    termDetails: propValidator([PROP_TYPES.OBJECT])
  },
  computed: {
    link() {
      return this.generateTermRoute(this.termDetails)
    },
    description() {
      return processHtml(this.termDetails.Description)
    },
    descriptionProps() {
      return {
        rowHeight: this.$_hydrationHelpers_mobileOrTabletOrDesktopValue(
          18,
          20,
          22
        ),
        rowCount: 4,
        to: this.link
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.term-tag-header__wrapper {
  .term-tag-header__description-wrapper {
    display: block;
    max-width: 1000px;
    margin-top: 20px;
  }

  .term-tag-header__description {
    white-space: pre-wrap;

    /deep/ a {
      color: $c--main;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
